import styles from './AccessBackOffice.css'

class AccessBackOffice extends React.Component {
  render () {
    let {onChange, checked, hasSubMenuChecked} = this.props
    return (
      <div className='row'>
        <div className='col-lg-1'>
          <div
            style={{marginTop: '2px'}}
            className={`checkbox checkbox-primary checkbox-circle ${!checked && hasSubMenuChecked ? styles['partial-checked'] : ''}`}
          >
            <input type='checkbox' id='access-back-office' onChange={onChange} checked={checked} />
            <label for='access-back-office' />
          </div>
        </div>
        <div className='col-lg-11' style={{marginLeft: '-5px'}}>
          <div className={`${styles['access-back-office-title']}`}>Access Back-office</div>
          <div className={`${styles['access-back-office-description']}`}>
              Allow this role to sign in to Moka Back-Office and access selected permissions.
          </div>
        </div>
      </div>
    )
  }
}

export default AccessBackOffice



// WEBPACK FOOTER //
// ./app/pages/Employees/Role/RoleDetail/RoleForm/AccessBackOffice/AccessBackOffice.js